export default "__VITE_ASSET__Cmln3oFA__"